import { FC } from "react";
import { CartellaModal } from "components/cartellaModal";
import { RenameModalConfig } from "../types";

type ModalProps = { config: RenameModalConfig | null; onClose: () => void };

export const RenameModal: FC<ModalProps> = (props) => {
  const { config } = props;

  const { path, isFolder, name } = config ?? {
    path: "",
    isFolder: true,
  };

  return (
    <CartellaModal
      show={Boolean(config)}
      closeModal={props.onClose}
      title={`Rinomina  ${isFolder ? " Cartella" : "file"}?`}
      inputValue={name}
      sourcePath={path}
      isFolder={isFolder}
    />
  );
};
